
import { computed, defineComponent } from 'vue'
import { useRoute } from 'vue-router';

export default defineComponent({
    setup()
    {
        const route = useRoute();

        /**
         * Get the layout defined for the current route.
         */
        const layout = computed(() : string => {
            return (route.meta.layout ?? 'default') + '-layout';
        });

        return { layout };
    },
})
